import Scanner from './Scanner'

export default Scanner
